module.exports = __webpack_public_path__ + "img/ydyj_bg.c5f4a4bc.png";